// dashboard/src/components/Interact/VideoScreen.tsx
import React, { useEffect, useRef } from "react";
import colors from "../../constants/colors";
import MediaWindow from "./MediaWindow";
// This component allows the user to replay/review their video after they have recorded themselves.

const bkgColor = colors.OFF_BRAND_INTERACT_BLUE;

interface VideoScreenProps {
  videoUrl: string;
  autoPlay?: boolean;
  paused?: boolean;
  onVideoEndOrPaused?: () => void;
  onVideoPlay?: () => void;
  maxWidth?: string;
}

const VideoScreen = ({
  videoUrl,
  maxWidth = "100%",   // Controls maximum width of the media window
  autoPlay,
  paused,
  onVideoEndOrPaused,
  onVideoPlay,
}: VideoScreenProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (paused === true) {
      videoRef.current?.pause();
    } else if (paused === false) {
      videoRef.current?.play();
    }
  }, [paused]);

  return (
    <MediaWindow backgroundColor={bkgColor} maxWidth={maxWidth}>
      <video
        key={videoUrl}
        onPause={() => {
          onVideoEndOrPaused?.();
        }}
        onEnded={() => {
          onVideoEndOrPaused?.();
        }}
        onPlay={() => {
          onVideoPlay?.();
        }}
        ref={videoRef}
        controls
        playsInline={true}  // Key attribute for iOS - prevents automatic fullscreen
        webkit-playsinline="true"  // Legacy webkit attribute for older iOS versions
        style={{
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain" // Ensure video fits within bounds without distortion
        }}
        src={videoUrl}
        autoPlay={autoPlay}
      ></video>
    </MediaWindow>
  );
};

export default VideoScreen;